import BigNumber from 'bignumber.js'
import { convertSharesToXp } from 'views/Pools/helpers'
import { multicallv2 } from 'utils/multicall'
import xpVaultAbi from 'config/abi/xpVault.json'
import { getXpVaultAddress } from 'utils/addressHelpers'
import { BIG_ZERO } from 'utils/bigNumber'

export const fetchPublicVaultData = async () => {
  try {
    const calls = [
      'getPricePerFullShare',
      'totalShares',
      'calculateHarvestXpRewards',
      'calculateTotalPendingXpRewards',
    ].map((method) => ({
      address: getXpVaultAddress(),
      name: method,
    }))

    const [[sharePrice], [shares], [estimatedXpBountyReward], [totalPendingXpHarvest]] = await multicallv2(
      xpVaultAbi,
      calls,
    )

    const totalSharesAsBigNumber = shares ? new BigNumber(shares.toString()) : BIG_ZERO
    const sharePriceAsBigNumber = sharePrice ? new BigNumber(sharePrice.toString()) : BIG_ZERO
    const totalXpInVaultEstimate = convertSharesToXp(totalSharesAsBigNumber, sharePriceAsBigNumber)
    return {
      totalShares: totalSharesAsBigNumber.toJSON(),
      pricePerFullShare: sharePriceAsBigNumber.toJSON(),
      totalXpInVault: totalXpInVaultEstimate.xpAsBigNumber.toJSON(),
      estimatedXpBountyReward: new BigNumber(estimatedXpBountyReward.toString()).toJSON(),
      totalPendingXpHarvest: new BigNumber(totalPendingXpHarvest.toString()).toJSON(),
    }
  } catch (error) {
    return {
      totalShares: null,
      pricePerFullShare: null,
      totalXpInVault: null,
      estimatedXpBountyReward: null,
      totalPendingXpHarvest: null,
    }
  }
}

export const fetchVaultFees = async () => {
  try {
    const calls = ['performanceFee', 'callFee', 'withdrawFee', 'withdrawFeePeriod'].map((method) => ({
      address: getXpVaultAddress(),
      name: method,
    }))

    const [[performanceFee], [callFee], [withdrawalFee], [withdrawalFeePeriod]] = await multicallv2(xpVaultAbi, calls)

    return {
      performanceFee: performanceFee.toNumber(),
      callFee: callFee.toNumber(),
      withdrawalFee: withdrawalFee.toNumber(),
      withdrawalFeePeriod: withdrawalFeePeriod.toNumber(),
    }
  } catch (error) {
    return {
      performanceFee: null,
      callFee: null,
      withdrawalFee: null,
      withdrawalFeePeriod: null,
    }
  }
}

export default fetchPublicVaultData
